import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, Observable } from 'rxjs';
import {
  DecrementActionRequests,
  DecrementLoadRequests,
  DecrementSearchRequests,
  IncrementActionRequests,
  IncrementLoadRequests,
  IncrementSearchRequests,
  SetLoadingBar,
  SetLoadingSpinner,
  SetSearchSpinner,
} from '../actions/progress.actions';
import {
  IS_ACTION,
  IS_LOAD,
  IS_SEARCH,
  SKIP_AUTH,
  SKIP_ERROR_HANDLER,
} from '../models/load.models';
import { EliquaFacadeService } from './eliqua.facade.service';
import { EnvironmentFacadeService } from './environment.facade.service';
import { ProgressFacadeService } from './progress.facade.service';

export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const progressFacade = inject(ProgressFacadeService);
  const environmentFacadeService = inject(EnvironmentFacadeService);
  const eliquaFacade = inject(EliquaFacadeService);

  let customRequest = req.context.get(SKIP_AUTH) ? req : req.clone({ withCredentials: true });
  const language = eliquaFacade.language;

  const isLoad = req.context.get(IS_LOAD);
  const isAction = req.context.get(IS_ACTION);
  const isSearch = req.context.get(IS_SEARCH);

  if (isLoad && progressFacade.totalLoadRequests === 0)
    progressFacade.dispatch(SetLoadingSpinner({ showSpinner: true }));
  if (isAction && progressFacade.totalActionRequests === 0)
    progressFacade.dispatch(SetLoadingBar({ showBar: true }));
  if (isSearch && progressFacade.totalSearchRequests === 0)
    progressFacade.dispatch(SetSearchSpinner({ showSearchSpinner: true }));

  if (isLoad) progressFacade.dispatch(IncrementLoadRequests());
  if (isAction) progressFacade.dispatch(IncrementActionRequests());
  if (isSearch) progressFacade.dispatch(IncrementSearchRequests());

  if (language) {
    customRequest = customRequest.clone({
      setHeaders: { 'Accept-Language': language },
    });
  }

  return next(customRequest).pipe(
    finalize(() => {
      if (isLoad) progressFacade.dispatch(DecrementLoadRequests());
      if (isAction) progressFacade.dispatch(DecrementActionRequests());
      if (isSearch) progressFacade.dispatch(DecrementSearchRequests());

      if (progressFacade.totalLoadRequests === 0 && isLoad)
        progressFacade.dispatch(SetLoadingSpinner({ showSpinner: false }));
      if (progressFacade.totalActionRequests === 0 && isAction)
        progressFacade.dispatch(SetLoadingBar({ showBar: false }));
      if (progressFacade.totalSearchRequests === 0 && isSearch)
        progressFacade.dispatch(SetSearchSpinner({ showSearchSpinner: false }));
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.context.get(SKIP_ERROR_HANDLER)) {
        const url = environmentFacadeService.IDP();
        window.location.replace(url);
      }
      throw error;
    }),
  );
};
